<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{this.parameterType === parameterTypeEnum.Payroll ? 'Información de nomina': 'Información de candado'}}</h4>
  <button type="button" class="btn close btn-default shadow-none" aria-label="Close" (click)="activeModal.dismiss(false)">
    <span class="material-icons-outlined">
      close
      </span>
  </button>
</div>
<div class="modal-body">
  <div class="row p-1" *ngIf="this.parameter">

    <div class="col-12 col-md-6">
      <div class="mx-auto">
        <label>ID de parámetro</label>
        <input placeholder="" type="text" [(ngModel)]="parameter.payrollID" name="parameter-payrollID" class="form-control">
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="mx-auto">
        <label>Titulo del parámetro</label>
        <input placeholder="" type="text" [(ngModel)]="parameter.title" name="parameter-title" class="form-control">
      </div>
    </div>

  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger me-2" (click)="this.activeModal.dismiss(false)">Cancelar</button>
  <button type="button" class="btn btn-primary me-2" (click)="createdParameter()">Crear Parámetro</button>
</div>
